/**
 * Creates daily counts for the given dates between a start and end date.
 *
 * @param dates - An array of date strings in ISO format (e.g., "2023-08-18T00:00:00Z").
 * @param startDate - The start date in ISO format (e.g., "2023-08-01").
 * @param endDate - The optional end date in ISO format (e.g., "2023-08-18"). Defaults to today.
 * @returns An object with labels (dates) and datasets for use in charting libraries.
 */
export const createDailyCounts = (
  dates: string[], 
  startDate: string, 
  endDate?: string
) => {
  const dateCounts: Record<string, number> = {};

  // Initialize dateCounts with all days between startDate and endDate
  const start = new Date(startDate);
  const end = endDate ? new Date(endDate) : new Date();
  for (let d = start; d <= end; d.setDate(d.getDate() + 1)) {
    const day = d.toISOString().split("T")[0];
    dateCounts[day] = 0;
  }

  // Count the number of events (hangouts/posts) for each day
  dates.forEach(date => {
    const day = date.split("T")[0]; // Extract the date part (YYYY-MM-DD)
    dateCounts[day] += 1;
  });

  // Convert the dateCounts object into an array of dates and counts
  const sortedDates = Object.keys(dateCounts).sort();
  const counts = sortedDates.map(date => dateCounts[date]);

  // if todays count is zero then remove it
  if (sortedDates[sortedDates.length - 1] === new Date().toISOString().split("T")[0] && counts.length > 1) {
    if (counts[counts.length - 1] === 0) {
      sortedDates.pop();
      counts.pop();
    }
  }

  return {
    labels: sortedDates,
    datasets: [
      {
        label: 'Daily Events',
        data: counts,
        fill: false,
        backgroundColor: '#1f77b4',
        borderColor: '#1f77b4',
        pointRadius: 1,
        borderWidth: 2,
      },
    ],
  };
};
